import React from 'react'
import { 
  ClockIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  ArrowRightIcon
} from '@heroicons/react/24/outline'

interface ModerationStatusProps {
  status: 'approved' | 'pending' | 'rejected'
  currentValue?: string | null
  pendingValue?: string | null
  label: string
  className?: string
}

export const ModerationStatus: React.FC<ModerationStatusProps> = ({
  status,
  currentValue,
  pendingValue,
  label,
  className = ''
}) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'approved':
        return <CheckCircleIcon className="w-4 h-4 text-green-600" />
      case 'pending':
        return <ClockIcon className="w-4 h-4 text-yellow-600" />
      case 'rejected':
        return <ExclamationTriangleIcon className="w-4 h-4 text-red-600" />
      default:
        return null
    }
  }

  const getStatusBadge = () => {
    switch (status) {
      case 'approved':
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
            <CheckCircleIcon className="w-3 h-3 mr-1" />
            Утверждено
          </span>
        )
      case 'pending':
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            <ClockIcon className="w-3 h-3 mr-1" />
            На модерации
          </span>
        )
      case 'rejected':
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
            <ExclamationTriangleIcon className="w-3 h-3 mr-1" />
            Отклонено
          </span>
        )
      default:
        return null
    }
  }

  const showComparison = status === 'pending' && currentValue && pendingValue && currentValue !== pendingValue

  return (
    <div className={`space-y-2 ${className}`}>
      {/* Заголовок с статусом */}
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
        {getStatusBadge()}
      </div>

      {/* Значения */}
      {showComparison ? (
        // Упрощенное сравнение ДО/ПОСЛЕ
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="text-xs text-gray-500 mb-1">Текущее</div>
              <div className="text-sm text-gray-900 bg-gray-50 px-3 py-2 rounded">
                {currentValue || '—'}
              </div>
            </div>
            
            <div>
              <div className="text-xs text-gray-500 mb-1">Предлагаемое</div>
              <div className="text-sm text-gray-900 bg-gray-50 px-3 py-2 rounded border border-gray-200">
                {pendingValue || '—'}
              </div>
            </div>
          </div>
        </div>
      ) : (
        // Показываем только текущее значение
        <div className="text-gray-900">
          {(status === 'pending' && pendingValue) ? pendingValue : (currentValue || '—')}
        </div>
      )}
    </div>
  )
}
